<template>
  <div>
    <div v-if="showEn == 0">
      <div class="admin-add">
        <div class="admin-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            class="fontSize"
            :label-width="115"
          >
            <FormItem label="Badge type:" :required="true" v-if="formInline.BadgeType">
              <Input type="text" v-model="formInline.BadgeType" :disabled="true"></Input>
            </FormItem>
            <FormItem label="Company name:" :required="true">
              <Input
                type="text"
                v-model="formInline.CompanyName"
                :disabled="true"
              ></Input>
            </FormItem>
            <FormItem label="Booth number:" :required="true">
              <Input type="text" v-model="formInline.BoothCode" :disabled="true"></Input>
            </FormItem>
            <!-- <FormItem label="ID photo:" prop='CardPicture'>
                            <div class="my-upload-list" v-for="(item, index) in uploadList1" :key="'upload' + index"
                                style="width: 100px;height: 100px;line-height:100px;margin-bottom:0;">
                                <template v-if="item.status === 'finished'">
                                    <img :src="item.url" style="width:100%;height:100%;" />
                                    <div class="my-upload-list-cover">
                                        <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                                        <Icon type="ios-trash-outline"
                                            @click.native.stop.prevent="handleRemoveByArr1(item)"></Icon>
                                    </div>
                                </template>
                                <template v-else>
                                    <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
                                        <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                                    </Spin>
                                </template>·
                            </div>
                            <Upload ref="upload1" :show-upload-list="false" :on-success="handleSuccess1"
                                :format="['jpg', 'jpeg', 'png']" :max-size="2048" :headers="formHeaders"
                                :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize"
                                :before-upload="handleBeforeUpload1" type="drag" :action="uploadUrl" multiple
                                style="display: inline-block;width:100px;"
                                v-show="uploadList1 && uploadList1.length < 1">
                                <div style="width: 100px;height:100px;padding-top:15px;color:rgb(133, 133, 133);">
                                    <div style="font-size:25px;">
                                        +
                                        <p style="font-size:12px;">Upload an image</p>
                                    </div>
                                </div>
                                <div style="position:absolute;opacity:0;width:100px;height:100px;left:0;top:0;"></div>
                            </Upload>

                        </FormItem> -->
            <FormItem label="Full name:" prop="FirstName">
              <Input
                type="text"
                v-model="formInline.FirstName"
                placeholder="Please enter your full name"
              ></Input>
            </FormItem>
            <FormItem label="ID number:" prop="IdCard">
              <Input
                type="text"
                v-model="formInline.IdCard"
                @on-blur="IdCardRemoveSpaces"
                placeholder="Please enter your ID number"
              ></Input>
            </FormItem>

            <FormItem label="Phone number:" prop="Tel" :required="true">
              <Input
                type="text"
                v-model="formInline.Tel"
                @on-blur="TelRemoveSpaces"
                placeholder="Please enter your phone number"
              ></Input>
            </FormItem>

            <FormItem label="Mailbox:" prop="Email" :required="true">
              <Input
                type="text"
                v-model="formInline.Email"
                @on-blur="EmailRemoveSpaces"
                placeholder="Please enter your email address"
              ></Input>
            </FormItem>
            <FormItem
              label="Verification code:"
              class="form-code-item"
              prop="Code"
              :required="true"
            >
              <Input
                type="text"
                v-model="formInline.Code"
                placeholder="Please enter your code"
              />
              <Button
                type="text"
                v-if="showCode"
                @click="getCaptchaMob"
                class="form-code-btn"
                >Get Code</Button
              >
              <Button type="text" v-else disabled class="form-code-btn"
                >{{ count }}s</Button
              >
            </FormItem>
            <FormItem label="Position:" prop="JobTitle" :required="true">
              <Input
                type="text"
                v-model="formInline.JobTitle"
                placeholder="Please enter your position"
              ></Input>
            </FormItem>
            <FormItem label="Country:" v-if="CountryList.length" prop="Country">
              <Select
                v-model="formInline.Country"
                filterable
                clearable
                @on-change="countryChange"
                placeholder="Please enter your country"
              >
                <Option v-for="item in CountryList" :value="item.label" :key="item.id">{{
                  item.label
                }}</Option>
              </Select>
            </FormItem>
            <FormItem
              label="Province:"
              v-if="
                formInline.Country == '中国/zhongguo' ||
                formInline.Country == '中国/China'
              "
              prop="Province"
            >
              <Select
                v-model="formInline.Province"
                filterable
                clearable
                @on-change="provinceChange"
                placeholder="Please enter your province"
              >
                <Option v-for="item in ProvinceList" :value="item.label" :key="item.id">{{
                  item.label
                }}</Option>
              </Select>
            </FormItem>
            <FormItem
              label="City:"
              v-if="
                formInline.Country == '中国/zhongguo' ||
                formInline.Country == '中国/China'
              "
              prop="City"
            >
              <Select
                v-model="formInline.City"
                filterable
                clearable
                @on-change="cityChange"
                placeholder="Please enter your city"
              >
                <Option v-for="item in CityList" :value="item.label" :key="item.id">{{
                  item.label
                }}</Option>
              </Select>
            </FormItem>
            <FormItem>
              <Button
                style="width: 130px"
                type="primary"
                :loading="loading2"
                @click="handleSubmit('formInline', 1)"
                >Submit</Button
              >
              <!-- <Button style="width:90px;" type="primary" @click="cancel">取消</Button> -->
            </FormItem>
          </Form>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="admin-add" v-if="BadgeTypeValue != 3">
        <div class="admin-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="110"
          >
            <FormItem label="证件类型:" :required="true" v-if="formInline.BadgeType">
              <Input type="text" v-model="formInline.BadgeType" :disabled="true"></Input>
            </FormItem>
            <FormItem label="公司名称:" :required="true">
              <Input
                type="text"
                v-model="formInline.CompanyName"
                :disabled="true"
              ></Input>
            </FormItem>
            <FormItem label="展位号:" :required="true">
              <Input type="text" v-model="formInline.BoothCode" :disabled="true"></Input>
            </FormItem>

            <!-- <FormItem label="地址：">
              <Input type="text" v-model="formInline.Address" placeholder="请输入地址"></Input>
            </FormItem> -->

            <!-- <FormItem label="本人证件照：" prop='CardPicture'>
                            <div class="my-upload-list" v-for="(item, index) in uploadList1" :key="'upload' + index"
                                style="width: 100px;height: 100px;line-height:100px;margin-bottom:0;">
                                <template v-if="item.status === 'finished'">
                                    <img :src="item.url" style="width:100%;height:100%;" />
                                    <div class="my-upload-list-cover">
                                        <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                                        <Icon type="ios-trash-outline"
                                            @click.native.stop.prevent="handleRemoveByArr1(item)"></Icon>
                                    </div>
                                </template>
                                <template v-else>
                                    <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
                                        <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                                    </Spin>
                                </template>·
                            </div>
                            <Upload ref="upload1" :show-upload-list="false" :on-success="handleSuccess1"
                                :format="['jpg', 'jpeg', 'png']" :max-size="2048" :headers="formHeaders"
                                :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize"
                                :before-upload="handleBeforeUpload1" type="drag" :action="uploadUrl" multiple
                                style="display: inline-block;width:100px;"
                                v-show="uploadList1 && uploadList1.length < 1">
                                <div style="width: 100px;height:100px;padding-top:15px;color:rgb(133, 133, 133);">
                                    <div style="font-size:25px;">
                                        +
                                        <p style="font-size:14px;">上传图片</p>
                                    </div>
                                </div>
                                <div style="position:absolute;opacity:0;width:100px;height:100px;left:0;top:0;"></div>
                            </Upload>

                        </FormItem> -->
            <FormItem label="姓名:" prop="FirstName">
              <Input
                type="text"
                v-model="formInline.FirstName"
                placeholder="请输入姓名"
              ></Input>
            </FormItem>
            <FormItem label="身份证号:" prop="IdCard">
              <Input
                type="text"
                v-model="formInline.IdCard"
                @on-blur="IdCardRemoveSpaces"
                placeholder="请输入身份证号"
              ></Input>
            </FormItem>

            <FormItem label="电话:" prop="Tel" :required="true">
              <Input
                type="text"
                v-model="formInline.Tel"
                @on-blur="TelRemoveSpaces"
                placeholder="请输入电话"
              ></Input>
            </FormItem>

            <FormItem label="邮箱:" prop="Email" :required="true">
              <Input
                type="text"
                v-model="formInline.Email"
                @on-blur="EmailRemoveSpaces"
                placeholder="请输入邮箱"
              ></Input>
            </FormItem>
            <FormItem label="验证码:" class="form-code-item" prop="Code" :required="true">
              <Input
                type="text"
                v-model="formInline.Code"
                placeholder="请输入手机验证码"
              />
              <Button
                type="text"
                v-if="showCode"
                @click="getCaptchaMob"
                class="form-code-btn"
                >获取手机验证码</Button
              >
              <Button type="text" v-else disabled class="form-code-btn"
                >{{ count }}s后重新获取</Button
              >
            </FormItem>
            <FormItem label="职务:" prop="JobTitle" :required="true">
              <Input
                type="text"
                v-model="formInline.JobTitle"
                placeholder="请输入职务"
              ></Input>
            </FormItem>
            <FormItem label="国家:" v-if="CountryList.length" prop="Country">
              <Select
                v-model="formInline.Country"
                filterable
                clearable
                @on-change="countryChange"
              >
                <Option v-for="item in CountryList" :value="item.label" :key="item.id">{{
                  item.label
                }}</Option>
              </Select>
            </FormItem>
            <FormItem
              label="省份:"
              v-if="
                formInline.Country == '中国/zhongguo' ||
                formInline.Country == '中国/China'
              "
              prop="Province"
            >
              <Select
                v-model="formInline.Province"
                filterable
                clearable
                @on-change="provinceChange"
              >
                <Option v-for="item in ProvinceList" :value="item.label" :key="item.id">{{
                  item.label
                }}</Option>
              </Select>
            </FormItem>
            <FormItem
              label="城市:"
              v-if="
                formInline.Country == '中国/zhongguo' ||
                formInline.Country == '中国/China'
              "
              prop="City"
            >
              <Select
                v-model="formInline.City"
                filterable
                clearable
                @on-change="cityChange"
              >
                <Option v-for="item in CityList" :value="item.label" :key="item.id">{{
                  item.label
                }}</Option>
              </Select>
            </FormItem>
            <FormItem>
              <Button
                style="width: 130px"
                type="primary"
                :loading="loading2"
                @click="handleSubmit('formInline', 1)"
                >完成</Button
              >
              <!-- <Button style="width:90px;" type="primary" @click="cancel">取消</Button> -->
            </FormItem>
          </Form>
        </div>
      </div>
      <div class="admin-add" v-else>
        <div class="">
          <Form
            ref="formInline1"
            :model="formInline1"
            :rules="ruleInline"
            label-position="left"
            :label-width="0"
          >
            <div><span class="Tips">*</span> 证件类型(Type of Certificate):</div>
            <FormItem label="" :required="true">
              <Input type="text" v-model="formInline1.BadgeType" :disabled="true"></Input>
            </FormItem>
            <div><span class="Tips">*</span>公司名称(Company):</div>
            <FormItem label="" :required="true">
              <Input
                type="text"
                v-model="formInline1.CompanyName"
                :disabled="true"
              ></Input>
            </FormItem>
            <div><span class="Tips">*</span>展位号(Booth Number)：</div>
            <FormItem label="" :required="true">
              <Input type="text" v-model="formInline1.BoothCode" :disabled="true"></Input>
            </FormItem>
            <!-- <FormItem label="地址：">
              <Input type="text" v-model="formInline.Address" placeholder="请输入地址"></Input>
            </FormItem> -->
            <div><span class="Tips">*</span>本人证件照(ID Photo):</div>
            <FormItem label="" prop="CardPicture">
              <div
                class="my-upload-list"
                v-for="(item, index) in uploadList1"
                :key="'upload' + index"
                style="width: 100px; height: 100px; line-height: 100px; margin-bottom: 0"
              >
                <template v-if="item.status === 'finished'">
                  <img :src="item.url" style="width: 100%; height: 100%" />
                  <div class="my-upload-list-cover">
                    <Icon
                      type="ios-eye-outline"
                      @click.native="handleView(item.url)"
                    ></Icon>
                    <Icon
                      type="ios-trash-outline"
                      @click.native.stop.prevent="handleRemoveByArr1(item)"
                    ></Icon>
                  </div>
                </template>
                <template v-else>
                  <Spin v-if="item.showProgress" style="width: 100px; height: 100px">
                    <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                  </Spin>
                </template>
              </div>
              <Upload
                ref="upload1"
                :show-upload-list="false"
                :on-success="handleSuccess1"
                :format="['jpg', 'jpeg', 'png']"
                :max-size="2048"
                :headers="formHeaders"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                :before-upload="handleBeforeUpload1"
                type="drag"
                :action="uploadUrl"
                multiple
                style="display: inline-block; width: 100px"
                v-show="uploadList1 && uploadList1.length < 1"
              >
                <div
                  style="
                    width: 100px;
                    height: 100px;
                    padding-top: 15px;
                    color: rgb(133, 133, 133);
                  "
                >
                  <div style="font-size: 25px">
                    +
                    <p style="font-size: 14px">上传图片</p>
                  </div>
                </div>

                <div
                  style="
                    position: absolute;
                    opacity: 0;
                    width: 100px;
                    height: 100px;
                    left: 0;
                    top: 0;
                  "
                ></div>
              </Upload>
            </FormItem>
            <div><span class="Tips">*</span>姓名(Name):</div>
            <FormItem label="" prop="FirstName">
              <Input
                type="text"
                v-model="formInline1.FirstName"
                placeholder="请输入姓名"
              ></Input>
            </FormItem>
            <div><span class="Tips">*</span>电话(Phone Number):</div>
            <FormItem label="" prop="TelEn">
              <Input
                type="text"
                v-model="formInline1.TelEn"
                @on-blur="TelEnRemoveSpaces"
                placeholder="请输入电话"
              ></Input>
            </FormItem>
            <div><span class="Tips">*</span>邮箱(Email):</div>
            <FormItem label="" prop="Email">
              <Input
                type="text"
                v-model="formInline1.Email"
                @on-blur="EmailEnRemoveSpaces"
                placeholder="请输入邮箱"
              ></Input>
            </FormItem>
            <div><span class="Tips">*</span>验证码(Verification Code)：</div>
            <FormItem label="" class="form-code-item" prop="Code">
              <Input
                type="text"
                v-model="formInline1.Code"
                placeholder="请输入邮箱验证码(Please enter the verification code)"
              />
              <Button
                type="text"
                v-if="showCode"
                @click="getCaptcha"
                class="form-code-btn"
                >Click here for a verification code</Button
              >
              <Button type="text" v-else disabled class="form-code-btn"
                >{{ count }}s后重新获取</Button
              >
            </FormItem>

            <div><span class="Tips">*</span>职务(Position):</div>
            <FormItem label="" prop="JobTitle">
              <Input
                type="text"
                v-model="formInline1.JobTitle"
                placeholder="请输入职位(Position)"
              ></Input>
            </FormItem>
            <div><span class="Tips">*</span>部门(Department):</div>
            <FormItem label="" prop="Department">
              <Input
                type="text"
                v-model="formInline1.Department"
                placeholder="请输入部门"
              ></Input>
            </FormItem>
            <!-- <div><span class="Tips">*</span>国家/地区(Country/Region):</div> -->
            <!-- <FormItem label="" v-if="CountryList.length" prop='Country'>
                            <Select  filterable clearable>
                                <Option v-for="item in CountryList" :value="item.id" :key="item.id">{{ item.label
                                }}</Option>
                            </Select>
                        </FormItem> -->
            <div><span class="Tips">*</span>国家/地区(Country/Region):</div>
            <FormItem label="" v-if="CountryList.length" prop="Country">
              <Select
                v-model="formInline1.Country"
                filterable
                clearable
                @on-change="countryChange"
              >
                <Option v-for="item in CountryList" :value="item.label" :key="item.id">{{
                  item.label
                }}</Option>
              </Select>
            </FormItem>
            <div
              v-if="
                formInline1.Country == '中国/zhongguo' ||
                formInline1.Country == '中国/China'
              "
            >
              <span class="Tips">*</span>省份/地区(Province):
            </div>
            <FormItem
              label=""
              v-if="
                formInline1.Country == '中国/zhongguo' ||
                formInline1.Country == '中国/China'
              "
              prop="Province"
            >
              <Select
                v-model="formInline1.Province"
                filterable
                clearable
                @on-change="provinceChange"
              >
                <Option v-for="item in ProvinceList" :value="item.label" :key="item.id">{{
                  item.label
                }}</Option>
              </Select>
            </FormItem>
            <div
              v-if="
                formInline1.Country == '中国/zhongguo' ||
                formInline1.Country == '中国/China'
              "
            >
              <span class="城市">*</span>城市(city):
            </div>
            <FormItem
              label=""
              v-if="
                formInline1.Country == '中国/zhongguo' ||
                formInline1.Country == '中国/China'
              "
              prop="City"
            >
              <Select
                v-model="formInline1.City"
                filterable
                clearable
                @on-change="cityChange"
              >
                <Option v-for="item in CityList" :value="item.label" :key="item.id">{{
                  item.label
                }}</Option>
              </Select>
            </FormItem>
            <div>
              <span class="Tips">*</span>护照号/港澳台通行证号(Passport No. / Hong Kong,
              Macau and Taiwan Exit & Entry Permit No):
            </div>
            <FormItem label="" prop="IdCardEn">
              <Input
                type="text"
                v-model="formInline1.IdCardEn"
                @on-blur="IdCardEnRemoveSpaces"
                placeholder="请输入护照号/港澳台通行证号"
              ></Input>
            </FormItem>
            <!-- <div>护照号/港澳台通行证照片( Photo of Passport / Hong Kong, Macao and Taiwan Exit & Entry Permit):</div>
                        <FormItem label="" :required="true" prop='Img'>
                            <div class="my-upload-list" v-for="(item, index) in uploadList" :key="'upload' + index"
                                style="width: 100px;height: 100px;line-height:100px;margin-bottom:0;">
                                <template v-if="item.status === 'finished'">
                                    <img :src="item.url" style="width:100%;height:100%;" />
                                    <div class="my-upload-list-cover">
                                        <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                                        <Icon type="ios-trash-outline"
                                            @click.native.stop.prevent="handleRemoveByArr(item)">
                                        </Icon>
                                    </div>
                                </template>
                                <template v-else>
                                    <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
                                        <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                                    </Spin>
                                </template>
                            </div>
                            <Upload ref="upload" :show-upload-list="false" :on-success="handleSuccess"
                                :format="['jpg', 'jpeg', 'png']" :max-size="2048" :headers="formHeaders"
                                :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize"
                                :before-upload="handleBeforeUpload" type="drag" :action="uploadUrl" multiple
                                style="display: inline-block;width:100px;" v-show="uploadList && uploadList.length < 1">
                                <div style="width: 100px;height:100px;padding-top:15px;color:rgb(133, 133, 133);">
                                    <div style="font-size:25px;">
                                        +
                                        <p style="font-size:14px;">上传图片</p>
                                    </div>
                                </div>
                                <div style="position:absolute;opacity:0;width:100px;height:100px;left:0;top:0;"></div>
                            </Upload>
                        </FormItem> -->

            <FormItem>
              <!-- <Button style="width:90px;" type="primary" :loading="loading" @click="handleSubmit('formInline',0)">继续添加</Button> -->
              <Button
                style="width: 130px; margin-right: 20px"
                type="primary"
                :loading="loading2"
                @click="handleSubmitEn('formInline1', 1)"
                >完成/Submit</Button
              >
              <!-- <Button style="width:90px;margin:0 20px" type="primary" @click="DownPdf">Print</Button> -->
              <span></span>
            </FormItem>
          </Form>
          <div>
            海外及港澳台提示（此提示放在海外及港澳台人员实名认证入口处）：
            <br />
            海外及港澳台人员进场须知
            <br />
            尊敬的医博会参会人员您好
            <br />
            请您入场前线上完成个人信息的填写，入场时请携带护照/港澳台通行证原件。
            <br />
            您的信息只用于参观入场认证使用，感谢您的配合，祝您参展顺利！
            <br />
            中国国际医疗博览会主办方
          </div>

          <div style="margin-top: 20px">
            Notice to visitors from overseas and Hong Kong, Macao and Taiwan
            <br />
            Dear CMEF visitors,
            <br />
            Please fill in your identity information online before entry and bring the
            original copy of your passport/ exit-entry permit for Hong Kong, Macao and
            Taiwan with you while entering.
            <br />
            Your identity information is only used for authentication at the entry. Thanks
            for your cooperation and wish you a pleasant visit!
            <br />
            CMEF Organizing Committee
          </div>
        </div>
      </div>
    </div>

    <iModal
      title="提示"
      v-model="showTips"
      class-name="vertical-center-modal"
      width="600px"
      :mask-closable="false"
      @on-cancel="showTips = false"
    >
      <div>提示：{{ msg }}</div>
      <div slot="footer">
        <Button style="width: 90px" type="primary" @click="confirm()">确认</Button>
        <Button style="width: 90px" type="primary" @click="showTips = false">取消</Button>
      </div>
    </iModal>
    <iModal
      title="提示"
      v-model="showerror"
      class-name="vertical-center-modal"
      width="600px"
      :mask-closable="false"
      :footer-hide="true"
    >
      <div v-if="applyForSpecifications == 1" style="font-size: 24px">
        尊敬的参展商您好：
      </div>
      <div v-else style="font-size: 24px">尊敬的CMEF参展商您好：</div>
      <template v-if="formInline.BadgeType === '展商证'">
        <div v-if="applyForSpecifications == 1">
          根据贵公司本届展会的展位面积，您可申请的展商证数量已达上限，感谢您的理解与配合，谢谢!
        </div>
        <div v-else>
          根据贵公司本届展会的展位面积，您可申请的展商证数量已达上限，如您有重要客户或重要人员需一同参会，请通过【特邀嘉宾】入口申请入场证件，感谢您的理解与配合，谢谢！
        </div>
        <div v-if="applyForSpecifications == 1" style="font-size: 12px; margin-top: 20px">
          【注】展商证申请数量规则：(展位面积/9m²)*4，以此类推。
        </div>
        <div v-else style="font-size: 12px; margin-top: 20px">
          【注】展商证申请数量规则：(展位面积/9m²)*3，以此类推。
        </div>
      </template>
      <template v-if="formInline.BadgeType === 'VIP'">
        <div>
          根据贵公司本届展会的展位面积，您可申请的VIP证数量已达上限，如您有重要客户或重要人员需一同参会，请通过【特邀嘉宾】入口申请入场证件，感谢您的理解与配合，谢谢！
        </div>
        <div style="font-size: 12px; margin-top: 20px">
          【注】VIP证申请数量规则：1张/90平米，以此类推。
        </div>
      </template>
    </iModal>

    <iModal
      title="提示"
      v-model="showDown"
      class-name="vertical-center-modal"
      width="600px"
      :mask-closable="false"
      @on-cancel="showDown = false"
    >
      <div>点击“确认”，查看认证信息。 (Please print the confirmation letter)</div>
      <div slot="footer">
        <Button style="width: 90px" type="primary" @click="down()">确认</Button>
      </div>
    </iModal>

    <!-- <iModal
      title="提示"
      width="600px"
      v-model="show"
      class-name="vertical-center-modal"
      :mask-closable="false"
      @on-cancel="show = false"
      :footer-hide="true"
    >
      <div>
        尊敬的展商您好，您的展商证认证已完成，如您的朋友需要参会，请进入iCMEF小程序或登录CMEF官网（中文：cmef.com.cn；英文：cmef.com.cn/en）、CMEF官方微信公众号进行观众预登记，谢谢！期待与您4月8日上海见！
      </div>
    </iModal> -->
    
    <iModal
      title="提示"
      width="600px"
      v-model="timesShow"
      class-name="vertical-center-modal"
      :styles="{ top: '30%' }"
      :closable="false"
      :mask-closable="false"
      @on-cancel="show = false"
      :footer-hide="true"
    >
      <div>
        <div>
          尊敬的展商您好，您的展商证认证已完成，如您的朋友需要参会，请进入iCMEF小程序或登录CMEF官网</br>中文：cmef.com.cn；</br>英文：cmef.com.cn/en；</br>CMEF官方微信公众号进行观众预登记，谢谢！期待与您10月21日首都国际会展中心见！
        </div>
        <div>
          Dear exhibitor, your exhibitor certificate has been verified. If your friends
          need to attend the event, please enter the iCMEF mini program or log in to the
          CMEF official website (Chinese: cmef.com.cn; English: cmef.com.cn/en) or the
          CMEF official WeChat public account to register as a visitor in advance. Thank
          you! Looking forward to seeing you in Shanghai on April 8th!
        </div>
      </div>
    </iModal>

    <iModal
      title="提示"
      width="600px"
      v-model="isShowEx"
      class-name="vertical-center-modal"
      :styles="{ top: '30%' }"
      :closable="false"
      :mask-closable="false"
      @on-cancel="show = false"
      :footer-hide="true"
    >
      <div style="padding: 10px" v-if="applyForSpecifications == 1">
        尊敬的展商您好：<br />
        您的展商认证已截止，如需了解更多展会详情，请进入展会官网（www.thisasean.com）谢谢！
      </div>
      <div style="padding: 10px" v-else>
      尊敬的展商您好：第94届CMEF展商认证已截止，观众入场门票、更多展会信息及展会预告请登录CMEF官网（cmef.com.cn/en）或CMEF官方iCMEF小程序获取，谢谢！期待明年上海再见！
      </div>
    </iModal>
  </div>
</template>

<script>
import config from "@assets/config.json";
import { validator } from "@/other/validator";
import { mapGetters, mapActions } from "vuex";
let moment = require("moment");
export default {
  name: "addCert",
  props: {
    // show: {
    //   type: Boolean,
    //   default: false,
    // },
    yesNumber: {
      type: Number,
      default: 0,
    },
    NoNumber: {
      type: Number,
      default: 0,
    },
  },
  data() {
    const viraIdcard = (rule, value, callback) => {
      if (value === "") {
        if (this.showEn == 0) {
          callback(new Error("Please enter your ID number"));
        } else {
          callback(new Error("请输入身份证号"));
        }
      }
      // else if (this.verification1 ==false&&this.check==true) {
      //   callback(new Error('请输入正确的海外证件'));
      // }
      else {
        callback();
      }
    };
    const viraIdPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入正确的手机号码"));
      }
      // else if (this.verification1 ==false&&this.check==true) {
      //   callback(new Error('请输入正确的海外证件'));
      // }
      else {
        callback();
      }
    };
    const Country = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择国家"));
      }
      // else if (this.verification1 ==false&&this.check==true) {
      //   callback(new Error('请输入正确的海外证件'));
      // }
      else {
        callback();
      }
    };
    const Img = (rule, value, callback) => {
      callback();
      // if (value === "") {
      //   callback(new Error("请上传个图片"));
      // }
      // else if (this.verification1 ==false&&this.check==true) {
      //   callback(new Error('请输入正确的海外证件'));
      // }
      // else {
      //
      // }
    };
    const CardPicture = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请上传个照片"));
      } else if (this.verification1 == false && this.check == true) {
        callback(new Error("请输入正确的海外证件"));
      } else {
        callback();
      }
    };
    const Tel = (rule, value, callback) => {
      if (value === "") {
        if (this.showEn == 0) {
          callback(new Error("Please enter your phone number"));
        } else {
          callback(new Error("请输入手机号"));
        }
      } else if (
        // !/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(
        //     value
        // )
        value.length > 15
      ) {
        if (this.showEn == 0) {
          callback(new Error("Please enter the correct number"));
        } else {
          callback(new Error("请输入正确的手机号"));
        }
      }
      // else if (this.verification1 ==false&&this.check==true) {
      //   callback(new Error('请输入正确的海外证件'));
      // }
      else {
        callback();
      }
    };
    // 提交
    const Email = (rule, value, callback) => {
      if (value === "") {
        if (this.showEn == 0) {
          callback(new Error("Please enter your email address"));
        } else {
          callback(new Error("请输入邮箱"));
        }
      } else if (
        !/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/.test(value)
      ) {
        if (this.showEn == 0) {
          callback(new Error("Please enter the correct email"));
        } else {
          callback(new Error("请输入正确的邮箱"));
        }
      }
      // else if (this.verification1 ==false&&this.check==true) {
      //   callback(new Error('请输入正确的海外证件'));
      // }
      else {
        callback();
      }
    };
    return {
      date1: "5月14日", // 期待见面的日子
      date2: "2026-10-20 12:00", // 提交展商认证的日子 
      timesShow: false,
      applyForSpecifications: 0,
      single: false,
      loading: false,
      loading2: false,
      showModal: true,
      verification1: false, //是否正则匹配通过
      check: false, //是否选择海外证件
      show: false,
      formInline: {
        BadgeType: "",
        BadgeType2: "",
        BoothCode: "",
        CompanyName: "",
        FirstName: "",
        JobTitle: "",
        Department: "",
        Tel: "",
        Email: "",
        IdCard: "",
        Code: "",
        CardPicture: "",
        Country: "",
        Province: "",
        City: "",
      },
      formInline1: {
        BadgeType: "",
        TelEn: "",
        BoothCode: "",
        CompanyName: "",
        Address: "",
        FirstName: "",
        JobTitle: "",
        Department: "",
        Img: "",
        Country: "",
        IdCardEn: "",
        Email: "",
        Code: "",
        CardPicture: "",
        Province: "",
        City: "",
      },
      model1: "IdCard",
      ruleInline: {
        // 效验规则
        CompanyName: [
          {
            required: true,
            message: "请输入公司名",
            trigger: "blur",
          },
        ],
        FirstName: [
          {
            required: true,
            message: this.showEn == 0 ? "Please enter your full name" : "请输入姓名",
            trigger: "blur",
          },
        ],
        IdCardEn: [
          {
            required: true,
            message: "请输入护照号",
            trigger: "blur",
          },
        ],
        IdCard: [
          {
            required: true,
            message: "",
            trigger: "blur",
            validator: viraIdcard,
          },
        ],
        JobTitle: [
          {
            required: true,
            message: this.showEn == 0 ? "Please enter your position" : "请输入职务",
            trigger: "blur",
          },
        ],
        Department: [
          {
            required: true,
            message: "请输入部门",
            trigger: "blur",
          },
        ],
        TelEn: [
          {
            required: true,
            message: "",
            trigger: "blur",
            validator: viraIdPhone,
          },
        ],
        Code: [
          {
            required: true,
            message: this.showEn == 0 ? "Please enter your code" : "请输入验证码",
            trigger: "blur",
          },
        ],
        Email: [{ validator: Email, trigger: "blur" }],
        Tel: [{ validator: Tel, trigger: "blur" }],
        // Country: [{ validator: Country, trigger: 'blur' }],
        Country: [{ required: true, message: "请选择国家", trigger: "change" }],
        Img: [{ validator: Img, trigger: "blur" }],
        Province: [{ required: true, message: "请选择省份", trigger: "change" }],
        City: [{ required: true, message: "请选择城市", trigger: "change" }],
        CardPicture: [{ validator: CardPicture, trigger: "blur" }],
        // Mob: validator.phone,
      },
      uploadList: [], //上传图片
      uploadList1: [], //上传图片
      CountryList: [],
      ProvinceList: [],
      CityList: [],
      showerror: false,
      showDown: false,
      typeList: [
        {
          value: "展商证",
          label: "展商证",
        },
      ],
      showTips: false,
      showCode: true, // 是否可以获取验证码
      count: "", // 获取验证码的秒数
      timer: null,
      msg: "",
      downId: "",
      regnumber: 0, // 已经注册数量
      joindata: null,

      isShowEx: false,
      ExhibitionName: "",
    };
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (this.company) {
        this.formInline.CompanyName = this.company.name;
      }
      if (!val) this.$emit("close");
    },
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
    }),

    header() {
      return this.$store.state.formHeaders.headers;
    },
    exhibitonId() {
      return this.$route.query.exhibitionId;
    },
    joinId() {
      return this.$route.query.joinId;
    },
    BadgeTypeValue() {
      return this.$route.query.badgeTypeValue;
    },
    showEn() {
      return this.$route.query.showEn || 1;
    },
  },
  created() {
    this.isExhibition();
    this.init();
  },
  methods: {
    ...mapActions({
      getJoinInfoNoAuth: "loginModule/getJoinInfoNoAuth",
      realAuth: "realAuth",
      getFormDate: "exhibitionModule/getFormDate",

      getCountryList: "exhibitionModule/getCountryList",
      getCityByParentId: "exhibitionModule/getCityByParentId",

      getEmailVerCode: "exhibitionModule/getEmailVerCode",
      getMsgCode: "exhibitionModule/getMsgCode",
      validateEmailCode: "exhibitionModule/validateEmailCode",
      validateMsgCode: "exhibitionModule/validateMsgCode",
      CheckRepeat: "exhibitionModule/CheckRepeat", //查重接口
      getExhibitionById: "exhibitionModule/getExhibitionById",
      GetListnotoken: "exhibitionModule/GetListnotoken",
      getCountryNew: "getCountryNew",
      //DownPdf:'exhibitionModule/DownPdf'
    }),

    async isExhibition() {
      let res = null;
      res = await this.getExhibitionById(this.exhibitonId);
      this.ExhibitionName = res.name;
      this.applyForSpecifications = res.applyForSpecifications;
      console.log(res, "res");
      const startTime = new Date(res.startTime);
      const now = new Date();
      if (startTime > now) {
        console.log("startTime 在未来");
      } else if (startTime <= now) {
        console.log("startTime 在过去");
        this.isShowEx = true;
        return;
      }
      // else {
      //   console.log("startTime 就是现在");
      // }

      let date = new Date(this.date2).getTime();
      let now1 = new Date().getTime();

      if (now1 > date) {
        this.isShowEx = true;
        return;
      }
    },
    async init() {
      console.log(this.$route.query.badgeTypeValue);
      let opt = {
        JoinId: this.joinId,
        BadgeTypeValue: this.BadgeTypeValue,
      };
      let data = await this.getFormDate(opt);
      if (data && data.boothInfo) {
        console.log(data, "joindata");
        this.joindata = data;
        await this.getnumber(data);
        this.formInline.BadgeType = data.badgeType;
        this.formInline1.BadgeType = data.badgeType;
        if (this.formInline.BadgeType == "展商证") {
          this.formInline.BadgeType2 = "特邀嘉宾";
        } else {
          this.formInline.BadgeType2 = "展商证";
        }
        this.formInline.CompanyName = data.companyName;
        this.formInline1.CompanyName = data.companyName;
        let boothInfo = JSON.parse(data.boothInfo);
        if (boothInfo.length) {
          this.formInline.BoothCode = boothInfo[0].Code;
          this.formInline1.BoothCode = boothInfo[0].Code;
        }
      }
      // if (this.BadgeTypeValue == 3) {
      this.getCountry();
      // }
    },
    async getnumber(data) {
      //查询认证数量
      let opt = {
        JoinId: data.joinId,
        FirstName: "",
        BadgeType: data.badgeType,
      };
      let body = await this.GetListnotoken(opt);
      if (body) {
        this.regnumber = body.length;
        console.log(this.regnumber, "ti查询认证数量ja");
      }
    },
    async handleSubmit(name, e) {
      if (!this.formInline.BoothCode) {
        this.$Message.error("您还没有展位号，请联系主办方后再来提交！");
        return;
      }

      this.loading2 = true;
      setTimeout(() => {
        this.loading2 = false;
      }, 5000);
      // await this.getnumber(this.joindata)
      console.log("111 this.formInline", this.formInline);
      let date = new Date(this.date2).getTime();
      let now = new Date().getTime();

      if (now > date) {
        this.timesShow = true;
        return;
      }
      console.log(this.date2, 111111111111, now > date);
      let form = this.formInline;
      let limitNumber = this.regnumber || 0;
      console.log("111 limitNumber", limitNumber);
      console.log("111 badgeTypeValue", this.BadgeTypeValue);
      // 展商证件
      let bool = true;
      // if (this.BadgeTypeValue == 1) {
      //     if (this.joindata.boothArea <= 9 && limitNumber >= 3) {
      //         this.$Message.error("申请证件数不能超过三张");
      //         bool = false;
      //     }
      //     if (this.joindata.boothArea > 9) {
      //         let count = parseInt(this.joindata.boothArea / 9);
      //         if (limitNumber > (3 * count)) {
      //             this.$Message.error("申请证件数超过限制数量");
      //             bool = false;
      //         }
      //     }
      // }
      // vip
      // if (this.BadgeTypeValue == 4) {
      //     if (this.joindata.boothArea < 90) {
      //         this.$Message.error("申请证件数超过限制数量");
      //         bool = false;
      //         return
      //     }

      //     // old
      //     if (this.joindata.boothArea <= 90 && limitNumber > 1) {
      //         this.$Message.error("申请证件数不能超过三张");
      //         bool = false;
      //     }
      //     if (this.joindata.boothArea > 90) {
      //         let count = parseInt(this.joindata.boothArea / 90);
      //         if (limitNumber > (1 * count)) {
      //             this.$Message.error("申请证件数超过限制数量");
      //             bool = false;
      //         }
      //     }
      // }
      if (!bool) return;
      let valid = await this.validForm(name);
      if (!valid) return;
      let validCode = await this.validCodeMob(); //手机验证码验证
      if (!validCode) return;

      // 实名验证
      if (this.check == false) {
        let info = await this.realAuth({
          idcard: this.formInline.IdCard,
          name: this.formInline.FirstName,
        });
        if (!info || !info.successed) {
          this.$Message.warning(info.msg, 50);
          return;
        }
      }
      if (this.tapClick == 1) {
        this.$Message.warning("点击过于频繁，请刷新页面");
        return;
      }
      let body = {
        ExhibitionId: this.exhibitonId,
        JoinId: this.joinId,
        DeExCardDown: {
          JoinId: this.joinId,
          BadgeType: form.BadgeType,
          CompanyName: form.CompanyName,
          FirstName: form.FirstName,
          JobTitle: form.JobTitle,
          Tel: form.Tel,
          Email: form.Email,
          Idcard: form.IdCard,
          BoothCode: form.BoothCode,
          CardPicture: form.CardPicture,
          Country: form.Country,
          Province: form.Province,
          City: form.City,
        },
      };
      this.tapClick = 1;
      // let data = await this.CheckRepeat(body)
      // if (data.successed) {
      this.$http.post("/api/DeExCardDown", body, this.header).then((res) => {
        if (res.status === 200 && res.data.successed) {
          if (this.applyForSpecifications == 1) {
            this.$Notice.success({
              title: "尊敬的展商您好：",
              // desc: '尊敬的展商您好，您的展商证认证已完成，如您的朋友需要参会请登录CME官网（cme.com.cn)或CMEF官微信公众号进行观处预登记，谢谢！期待与您5月14日上海见！',
              desc:
                "您的展商认证已完成，如您的朋友需要参会，请进入展会官网（www.thisasean.com）申请观众胸卡注册谢谢！期待与您7月28日马来西亚吉隆坡现场见！",
            });
          } else {
            this.$Notice.success({
              title: "尊敬的展商您好：",
              desc:
                "尊敬的展商您好，您的展商证认证已完成，如您的朋友需要参会，请进入iCMEF小程序或登录CMEF官网</br>中文：cmef.com.cn；</br>英文：cmef.com.cn/en；</br>CMEF官方微信公众号进行观众预登记，谢谢！期待与您10月21日首都国际会展中心见！",
            });
          }
          if (this.exhibitonId != 'ec6c5271-2bdd-48c7-9984-26ef50d21f4f') { // 不是马来西亚，弹出
            this.showDown = true; //弹出下载PDF弹窗
          }
          this.downId = res.data.info.id;
          this.$refs["formInline"].resetFields();
          this.formInline.FirstName = "";
          this.formInline.JobTitle = "";
          this.formInline.Tel = "";
          this.formInline.Email = "";
          this.formInline.IdCard = "";
          this.formInline.CardPicture = "";
          this.formInline.Country = "";
          this.formInline.Province = "";
          this.formInline.City = "";
          this.ProvinceList = [];
          this.CityList = [];
          this.uploadList1 = [];
          this.uploadList = [];
          this.$refs.upload1.fileList = [];
          this.$refs.upload.fileList = [];
          this.tapClick = 0;
        } else {
          if (res.data.msg == "申请数量已超限，无法申请") {
            this.showerror = true;
            this.tapClick = 0;
          } else {
            this.$Message.error(res.data.msg);
            this.tapClick = 0;
          }
        }
      });
      // } else {

      //     if (data.msg !== '-1') {
      //         this.showTips = true
      //         this.msg = data.msg
      //     } else {

      //         if (data.msg == '申请数量已超限，无法申请') {
      //             this.showerror = true
      //         } else {
      //             this.$Message.warning(data.msg)
      //         }
      //     }
      // }
    },
    down() {
      this.showDown = false;
      window.open(
        `${config.api.reqApi}/Pdf/GetDeExCardDownEn?Id=` +
          this.downId +
          "&BoothCode=" +
          this.formInline1.BoothCode,
        "_blank"
      );
    },
    //海外版本提交表单
    async handleSubmitEn(name, e) {
      if (!this.formInline.BoothCode) {
        this.$Message.error(
          "您还没有展位号，请联系主办方后再来提交！/ You don't have a booth number yet, please contact the organizer and submit it again!"
        );
        return;
      }
      this.loading2 = true;
      // let date = '2023-5-12 23:59'
      // let now = new Date().getTime()
      // this.show = true
      setTimeout(() => {
        this.loading2 = false;
      }, 5000);
      // return

      let date = new Date(this.date2).getTime();
      let now = new Date().getTime();
      if (now > date) {
        this.timesShow = true;
        return;
      }
      // if (moment(now).format('YYYY-MM-DD HH:mm') > date) {
      //     this.show = true
      //     this.loading2 = false
      //     return
      // }
      let form = this.formInline1;
      console.log(form);
      let valid = await this.validForm(name);
      if (!valid) return;
      let validCode = await this.validCode();
      if (!validCode) return;
      if (this.tapClick == 1) {
        this.$Message.warning("Refresh and retry");
        return;
      }
      let body = {
        ExhibitionId: this.exhibitonId,
        JoinId: this.joinId,
        DeExCardDown: {
          JoinId: this.joinId,
          BadgeType: form.BadgeType,
          CompanyName: form.CompanyName,
          FirstName: form.FirstName,
          JobTitle: form.JobTitle,
          Country: form.Country,
          Email: form.Email,
          Img: form.Img,
          BoothCode: form.BoothCode,
          IDcard: form.IdCardEn,
          CardPicture: form.CardPicture,
          Tel: form.TelEn,
          Department: form.Department,
          Province: form.Province,
          City: form.City,
        },
      };
      this.tapClick = 1;
      let data = await this.CheckRepeat(body);
      if (data.successed) {
        this.$http.post("/api/DeExCardDown", body, this.header).then((res) => {
          if (res.status === 200 && res.data.successed) {
            if (this.applyForSpecifications == 1) {
              this.$Notice.success({
                title: "尊敬的展商您好：",
                // desc: '尊敬的展商您好，您的展商证认证已完成，如您的朋友需要参会请登录CME官网（cme.com.cn)或CMEF官微信公众号进行观处预登记，谢谢！期待与您5月14日上海见！',
                desc:
                  "您的展商认证已完成，如您的朋友需要参会，请进入展会官网（www.thisasean.com）</br>谢谢！期待与您10月21日首都国际会展中心见！",
              });
            } else {
              this.$Notice.success({
                title: "尊敬的展商您好：",
                desc:
                "尊敬的展商您好，您的展商证认证已完成，如您的朋友需要参会，请进入iCMEF小程序或登录CMEF官网</br>中文：cmef.com.cn；</br>英文：cmef.com.cn/en；</br>CMEF官方微信公众号进行观众预登记，谢谢！期待与您10月21日首都国际会展中心见！",
              });
            }

            this.showDown = true; //弹出下载PDF弹窗
            this.downId = res.data.info.id;
            this.loading = false;
            this.$refs["formInline1"].resetFields();
            this.formInline1.FirstName = "";
            this.formInline1.JobTitle = "";
            this.formInline1.Tel = "";
            this.formInline1.Email = "";
            this.formInline1.IdCardEn = "";
            this.formInline1.Img = "";
            this.formInline1.Country = "";
            this.formInline1.CardPicture = "";
            this.formInline1.Province = "";
            this.formInline1.City = "";
            this.ProvinceList = [];
            this.CityList = [];
            this.$refs.upload1.fileList = [];
            this.$refs.upload.fileList = [];
            this.uploadList = [];
            this.tapClick = 0;
          } else {
            if (res.data.msg == "申请数量已超限，无法申请") {
              this.showerror = true;
              this.tapClick = 0;
            } else {
              this.$Message.error(res.data.msg);
              this.tapClick = 0;
            }
          }
        });
      } else {
        this.$Message.warning(data.msg);
      }
    },
    //确认覆盖信息
    confirm() {
      if (this.msg == "未找到公司") {
        this.showTips = false;
        return;
      }
      let form = this.formInline;
      console.log(form, "覆盖信息");
      let body = {
        ExhibitionId: this.exhibitonId,
        JoinId: this.joinId,
        DeExCardDown: {
          JoinId: this.joinId,
          BadgeType: form.BadgeType,
          CompanyName: form.CompanyName,
          FirstName: form.FirstName,
          JobTitle: form.JobTitle,
          Tel: form.Tel,
          Email: form.Email,
          Idcard: form.IdCard,
          BoothCode: form.BoothCode,
          CardPicture: form.CardPicture,
          Country: form.Country,
          Province: form.Province,
          City: form.City,
        },
      };
      this.$http.post("/api/DeExCardDown", body, this.header).then((res) => {
        if (res.status === 200 && res.data.successed) {
          this.$Notice.success({
            title: "尊敬的展商您好：",
            desc:
                "尊敬的展商您好，您的展商证认证已完成，如您的朋友需要参会，请进入iCMEF小程序或登录CMEF官网</br>中文：cmef.com.cn；</br>英文：cmef.com.cn/en；</br>CMEF官方微信公众号进行观众预登记，谢谢！期待与您10月21日首都国际会展中心见！",
          });
          this.showTips = false;
          this.loading = false;
          this.$refs["formInline"].resetFields();
          this.formInline.FirstName = "";
          this.formInline.JobTitle = "";
          this.formInline.TelEn = "";
          this.formInline.Email = "";
          this.formInline.IdCard = "";
          this.formInline.CardPicture = "";
          this.formInline.Country = "";
          this.formInline.Province = "";
          this.formInline.City = "";
          this.ProvinceList = [];
          this.CityList = [];
          this.uploadList1 = [];
          this.uploadList = [];
          this.loading2 = false;
        } else {
          this.loading2 = false;
          if (res.data.msg == "申请数量已超限，无法申请") {
            this.showerror = true;
          } else {
            this.$Message.error("添加失败，请重新尝试");
          }
        }
      });
    },
    validForm(name) {
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          resolve(valid);
        });
      });
    },
    cancel() {
      this.$refs["formInline"].resetFields();
      this.formInline.FirstName = "";
      this.formInline.JobTitle = "";
      this.formInline.Tel = "";
      this.formInline.Email = "";
      this.formInline.IdCard = "";
      this.formInline.Country = "";
      this.formInline.Province = "";
      this.formInline.City = "";
      this.$emit("close");
    },

    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
        this.formInline1.Img = file.url;
      }
    },
    handleFormatError(file) {
      this.$Message.warning(`文件格式是不正确的, 请上传jpg或者png格式的图片`);
    },
    handleMaxSize(file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于2M的图片`);
    },
    handleBeforeUpload() {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Message.warning(`最多上传${limitNum}张图片`);
      }
      return check;
    },
    handleRemoveByArr(file) {
      const fileList = this.uploadList;
      this.formInline1.Img = "";
      this.uploadList.splice(fileList.indexOf(file), 1);
    },

    handleSuccess1(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList1 = this.$refs.upload1.fileList;
        if (this.BadgeTypeValue != 3) {
          this.formInline.CardPicture = file.url;
        } else {
          this.formInline1.CardPicture = file.url;
        }
      }
    },
    handleBeforeUpload1() {
      const limitNum = 1;
      const check = this.uploadList1.length < limitNum;
      if (!check) {
        this.$Message.warning(`最多上传${limitNum}张图片`);
      }
      return check;
    },
    handleRemoveByArr1(file) {
      const fileList = this.uploadList1;
      if (this.BadgeTypeValue != 3) {
        this.formInline.CardPicture = "";
      } else {
        this.formInline1.CardPicture = "";
      }
      this.uploadList1.splice(fileList.indexOf(file), 1);
    },
    //验证码获取
    getCaptcha() {
      this.$refs.formInline1.validateField("Email", (val) => {
        if (val !== "") return;
        this.downTime();
      });
    },
    async downTime() {
      let opt = {
        Email: this.formInline1.Email,
        Language: "3",
      };
      const valid = await this.getEmailVerCode(opt);
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.showCode = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.showCode = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    //手机验证码验证
    getCaptchaMob() {
      this.$refs.formInline.validateField("Tel", (val) => {
        if (val !== "") return;
        this.downTimeMob();
      });
    },
    async downTimeMob() {
      let opt = {
        Phone: this.formInline.Tel,
        Language: "2",
      };
      const valid = await this.getMsgCode(opt);
      console.log(valid, "123");
      if (!valid.successed) {
        this.$Message.warning("请输入有效手机号");
      }
      const TIME_COUNT = 60;
      console.log(this.timer);
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.showCode = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.showCode = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    async validCode() {
      if (!this.formInline1.Code) return false;
      let valid = await this.validateEmailCode({
        Email: this.formInline1.Email,
        Code: this.formInline1.Code,
      });
      if (!valid) {
        this.$Message.error("验证未通过!");
        return false;
      }
      if (valid.errors && valid.errors[0]) {
        if (valid.errors[0].code === -1) {
          this.$Message.error("无效的验证码");
          return;
        }
        this.$Message.error(valid.errors[0].description);
        return false;
      }
      return true;
    },
    async validCodeMob() {
      if (!this.formInline.Code) return false;
      let valid = await this.validateMsgCode({
        Phone: this.formInline.Tel,
        Code: this.formInline.Code,
      });
      if (!valid) {
        this.$Message.error("验证未通过!");
        return false;
      }
      if (valid.errors && valid.errors[0]) {
        if (valid.errors[0].code === -1) {
          this.$Message.error("无效的验证码");
          return;
        }
        this.$Message.error(valid.errors[0].description);
        return false;
      }
      return true;
    },

    //获取国家列表
    async getCountry() {
      let data = await this.getCountryNew();
      console.log(data, "data");
      if (data.length) {
        let arr = [];
        data.forEach((e) => {
          // arr.push({
          //     label: e.name + '/' + e.nameEn,
          //     value: e.name + '/' + e.nameEn,
          // })
          e.label = e.name + "/" + e.pinyin;
        });
        this.CountryList = data;
      }
    },
    // 国家点击事件
    async countryChange(val) {
      this.CountryList.map((e) => {
        if (val == e.label) {
          // this.formInline.Country=e.label
          // this.formInline1.Country=e.label
          this.getProvince(e.id);
        }
      });
      console.log(this.formInline.Country);
    },

    // 获取省份
    async getProvince(id) {
      let data = this.CountryList[0].childrens;
      console.log(data, "data");
      //    if (data.length) {

      data.forEach((e) => {
        e.label = e.name + "/" + e.pinyin;
      });
      this.formInline.Province = "";
      this.formInline1.Province = "";
      this.ProvinceList = [];
      this.formInline.City = "";
      this.formInline1.City = "";
      this.CityList = [];

      this.ProvinceList = data;

      // }
      console.log(this.ProvinceList, "ProvinceList");
    },
    // 省份点击事件
    async provinceChange(val) {
      console.log(val);
      this.ProvinceList.map((e) => {
        if (val == e.label) {
          // this.formInline.Country=e.label
          // this.formInline1.Country=e.label
          this.formInline.City = "";
          this.formInline1.City = "";
          this.CityList = [];
          e.childrens.forEach((e) => {
            e.label = e.name + "/" + e.pinyin;
          });
          this.CityList = e.childrens;
        }
      });

      console.log(this.formInline.Province);
    },

    // 获取城市
    async getCity(id) {
      let data = await this.getCityByParentId(id);
      //    if (data.length) {

      // data.forEach((e) => {
      //     e.label=e.name
      // })
      this.formInline.City = "";
      this.formInline1.City = "";
      this.CityList = [];
      this.CityList = data;
      // }
      console.log(this.CityList);
    },

    // 城市点击事件
    async cityChange(val) {
      this.CityList.map((e) => {
        if (val == e.name) {
          // this.formInline.City=e.name
          // this.formInline1.City=e.name
        }
      });
      console.log(this.formInline.City);
    },

    // 去除输入框空格
    IdCardRemoveSpaces() {
      this.formInline.IdCard = this.formInline.IdCard.replace(/\s/g, ""); // 使用正则表达式去除空格
    },
    TelRemoveSpaces() {
      this.formInline.Tel = this.formInline.Tel.replace(/\s/g, ""); // 使用正则表达式去除空格
    },
    EmailRemoveSpaces() {
      this.formInline.Email = this.formInline.Email.replace(/\s/g, ""); // 使用正则表达式去除空格
    },

    IdCardEnRemoveSpaces() {
      this.formInline1.IdCardEn = this.formInline1.IdCardEn.replace(/\s/g, ""); // 使用正则表达式去除空格
    },
    TelEnRemoveSpaces() {
      this.formInline1.TelEn = this.formInline1.TelEn.replace(/\s/g, ""); // 使用正则表达式去除空格
    },
    EmailEnRemoveSpaces() {
      this.formInline1.Email = this.formInline1.Email.replace(/\s/g, ""); // 使用正则表达式去除空格
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .ivu-modal {
  padding-bottom: 30px;
  top: 50px;
}

.Tips {
  color: red;
}

.admin-add {
  background-color: #fff;
  min-height: 100vh;
  padding: 10% 5%;
}

.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }

  &-content {
    .submit {
      display: flex;
      justify-content: center;

      button {
        margin-left: -75px;
      }
    }

    img {
      width: 150px;
      height: 150px;
    }
  }

  .form-code-item {
    position: relative;

    .form-code-btn {
      position: absolute;
      right: 1px;
      height: 28px;
      top: 3px;
      border: none;
      outline: none;

      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}

.fontSize /deep/ .ivu-form-item-label {
  font-size: 12px;
}
</style>
